module.exports = __webpack_public_path__ + "img/creditcard_fill.9f77ff74.svg";